import { useSelector } from 'store';
import { collectCompanyIdCandidates, isFunnerInternalCompany } from 'utils/funnerInternalCompany';

/**
 * גישה לפיצ'רים פנימיים של Funner (אותו תנאי כמו `/ops-console`).
 * `isReady` — יש לפחות מזהה חברה אחד; בלי זה אסור להסיק «לא מורשה».
 */
export default function useFunnerInternalAccess(): { isReady: boolean; isAllowed: boolean } {
  const userCompanyId = useSelector((state) => state.user?.CompanyId);
  const companyId = useSelector((state) => state.company?.CompanyId);
  const storedCompanyId = typeof window !== 'undefined' ? localStorage.getItem('companyId') : null;
  const candidateIds = collectCompanyIdCandidates(userCompanyId, companyId, storedCompanyId);

  return {
    isReady: candidateIds.length > 0,
    isAllowed: candidateIds.some(isFunnerInternalCompany),
  };
}
